import { Block, CheckCircle } from "@mui/icons-material";

export const insurancePolicyListColumns = [
    {
        Header: 'Provider',
        accessor: 'provider.name',
        enableFilter: false
    },
    {
        Header: 'Policy #',
        accessor: 'policyNumber',
        enableFilter: true
    },
   
];